var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-visualization',{scopedSlots:_vm._u([{key:"reservoir-info",fn:function(ref){
var data = ref.reservoirInfo;
return [_c('b-form-group',{attrs:{"label":"Cota montante"}},[_c('b-input-group',{attrs:{"append":"m"}},[_c('swx-number-input',{attrs:{"value":data.quota_flux,"name":"quota_flux","disabled":""}})],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }